import {
  SAVE_REPORT,
  UPDATE_REPORT,
  GET_REPORTS,
  GET_PROGRESS,
  DELETE_REPORT,
  UPDATE_PROGRESS,
  ADD_PROJECT_PROGRESS_HISTORY_FILES,
  CREATE_CUSTOM_EXPORT,
  GET_CUSTOM_EXPORTS,
  UPDATE_CUSTOM_EXPORT,
  DELETE_CUSTOM_EXPORT,
  GET_USER_CUSTOM_EXPORT_FILTER_VIEWS,
  CREATE_USER_CUSTOM_EXPORT_FILTER_VIEW,
  UPDATE_USER_CUSTOM_EXPORT_FILTER_VIEW,
  DELETE_USER_CUSTOM_EXPORT_FILTER_VIEW,
} from '../../state/actionTypes';

const initialState = {
  reports: [],
  customExports: [],
  customExportFilters: [],
};

const upsertCustomExportById = (list, row) => {
  const idx = list.findIndex((e) => e.id === row.id);
  if (idx === -1) return list.concat([row]);
  const next = list.slice();
  next[idx] = { ...list[idx], ...row };
  return next;
};

export default function projectActions(state = initialState, action = {}) {
  switch (action.type) {
    case GET_REPORTS:
    case SAVE_REPORT:
    case UPDATE_REPORT:
      return {
        ...state,
        reports: action.payload.reports,
      };
    case GET_PROGRESS:
    case UPDATE_PROGRESS:
    case ADD_PROJECT_PROGRESS_HISTORY_FILES:
      return {
        ...state,
        progress: action.payload.progress,
      };
    case DELETE_REPORT:
      return {
        ...state,
        reports: state.reports.filter(({ id }) => id !== action.payload.reportId),
      };
    case GET_CUSTOM_EXPORTS: {
      const {
        payload: { customExports = [] } = {},
      } = action;
      return {
        ...state,
        customExports,
      };
    }
    case CREATE_CUSTOM_EXPORT: {
      const {
        payload: { customExport = {} } = {},
      } = action;
      const { customExports = [] } = state;
      return {
        ...state,
        customExports: upsertCustomExportById(customExports, customExport),
      };
    }
    case UPDATE_CUSTOM_EXPORT: {
      const {
        payload: {
          id,
          customExport = {},
        } = {},
      } = action;
      const { customExports = [] } = state;
      const existing = customExports.find((e) => e.id === id);
      const merged = {
        ...(existing || {}),
        ...customExport,
        id,
      };
      return {
        ...state,
        customExports: upsertCustomExportById(customExports, merged),
      };
    }
    case DELETE_CUSTOM_EXPORT: {
      const {
        payload: {
          id,
        } = {},
      } = action;
      const { customExports = [] } = state;
      return {
        ...state,
        customExports: customExports.filter((existingExport) => (
          existingExport.id !== id
        )),
      };
    }
    case GET_USER_CUSTOM_EXPORT_FILTER_VIEWS:
    case CREATE_USER_CUSTOM_EXPORT_FILTER_VIEW:
    case UPDATE_USER_CUSTOM_EXPORT_FILTER_VIEW:
    case DELETE_USER_CUSTOM_EXPORT_FILTER_VIEW:
      return {
        ...state,
        customExportFilters: action.payload.customExportFilters,
      };
    default:
      return state;
  }
}
